'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const FlashlightIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M7.41614 6.09026H16.5839M9.9753 13.6136V10.4994L9.71836 10.0986L7.43669 6.44998C7.43669 6.44998 7.43669 6.4397 7.41614 6.41915V3.52081H16.5839V6.41915L16.5634 6.44998L14.2817 10.0986L14.0247 10.4994V19.6672C14.0247 20.1194 13.665 20.4791 13.2128 20.4791H10.777C10.3247 20.4791 9.96503 20.1194 9.96503 19.6672V13.6136H9.9753Z",
          stroke: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M12.5139 12H11.4861V14.0556H12.5139V12Z", fill: "currentColor" })
    ]
  }
);
const VpFlashlightIcon = forwardRef(FlashlightIcon);

export { VpFlashlightIcon as default };
